module.exports = __webpack_public_path__ + "img/uz.b601e9f.webp";